import { auth, functions } from './firebase';
import { createUserDocument, createCandidateUserDocument, createUserDocumentWithGoogle } from './user';

export const signupWithGoogle = async (details) => {
    await createUserDocumentWithGoogle(details);
    return details;
}

export const signup = async (details) => {
    const resp = await auth.createUserWithEmailAndPassword(details.email, details.password);
    var user = resp.user;
    await user.updateProfile({ displayName: details.fullName });
    await createUserDocument(user, details);
    return user;
}

export const candidateSignup = async (details) => {
    const resp = await auth.createUserWithEmailAndPassword(details.email, details.password);
    var user = resp.user;
    await user.updateProfile({ displayName: details.fullName });
    await createCandidateUserDocument(user, details);
    return user;
}

export const logout = async () => {
    return await auth.signOut();
}

export const login = async ({ email, password }) => {
    const resp = await auth.signInWithEmailAndPassword(email, password);
    return resp.user;
}

export const addUserInRole = functions.httpsCallable('addUserInRole');

export const checkIsUserExistsOrNot = async (email) => {
    var response = await auth.fetchSignInMethodsForEmail(email);
    return response;
}